import api from './api';

// Public endpoint — no auth token required.
export async function submitSupportRequest({ name, email, problem, details }) {
  const response = await api.post('/support', { name, email, problem, details });
  return response.data;
}
